export default {
    _cartoon_pop: 'cartoon_pop',
    _click: 'click',
    _correct: 'correct',
    _incorrect: 'incorrect',
    _jingle_bells_guitar: 'jingle_bells_guitar',
    _jingle_bells_piano: 'jingle_bells_piano',
    _sleigh_bells_01_loop: 'sleigh_bells_01_loop',
}